<template>
    <div class="app-wrapper">
        <el-container :key="$route.fullPath" direction="vertical">
            <page-header></page-header>
            <el-container class="max-main page-container" style="margin-top: -70px;">
                <page-sidebar></page-sidebar>
                <el-main class="page-main">
                    <page-title></page-title>
                    <router-view tag="main" />
                </el-main>
                <el-backtop :bottom="80"></el-backtop>
                <Player></Player>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import PageHeader from './components/pageHeader';
import PageSidebar from './components/pageSidebar';
import Player from '@/components/Player';
import PageTitle from '@/layout/components/pageTitle';
export default {
    components: { PageHeader, PageSidebar, Player, PageTitle }
};
</script>

<style lang="scss"></style>
